import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function LasVegasHero() {
  return <section id="herolasvegasrefrigeratedrentals" data-nav="light" className="relative overflow-hidden bg-background text-foreground py-20 md:py-28 lg:py-32 border-b border-border isolate">
      {/* Subtle decorative background gradient accent */}
      <div className="pointer-events-none absolute inset-0 -z-10 flex items-center justify-center overflow-hidden" aria-hidden="true">
        <div className="h-[28rem] w-[50rem] rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute right-0 top-1/4 h-72 w-72 rounded-full bg-accent/40 blur-2xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h1 className="font-default text-4xl font-extrabold tracking-tight sm:text-5xl md:text-6xl text-foreground">
            Refrigerated Trailer Rentals in Las Vegas
          </h1>

          <p className="mt-6 text-base sm:text-lg md:text-xl leading-relaxed text-muted-foreground font-normal">
            Fridge Fleet provides mobile refrigerated and freezer trailer options for temporary cold storage in Las Vegas and listed Southern Nevada communities. Trailer options include 6×8, 7×12, and 7×16 trailers plus a 53-foot reefer trailer. Coverage, availability, specifications, temperature requirements, site access, power or fuel needs, rental terms, and scheduling are confirmed with each quote.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="w-full sm:w-auto px-8 py-6 text-base font-semibold" asChild>
              <Link to="/ContactRequestAQuotePage">
                Request a Quote
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>

            <Button size="lg" variant="outline" className="w-full sm:w-auto px-8 py-6 text-base font-semibold border-border bg-card hover:bg-muted" asChild>
              <a href="tel:2135218821">
                <Phone className="mr-2 size-5 text-primary" />
                Call 213-521-8821
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}